import * as React from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';

import { useKeycloak } from '@react-keycloak/web';
import { useHasRealmRole } from '../utils/hooks';
import NotAuthorized from '../pages/NotAuthorized';

interface PrivateRouteParams extends RouteProps {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
}

const PrivateRoute = ({
  component: Component,
  ...rest
}: PrivateRouteParams & { role?: string }) => {
  const { keycloak } = useKeycloak();
  const hasRole = useHasRealmRole(rest.role || 'professional');

  return (
    <Route
      {...rest}
      render={(props: any) => {
        if (keycloak?.authenticated && !keycloak?.isTokenExpired()) {
          return hasRole ? <Component {...props} /> : <NotAuthorized />;
        }

        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.defaultProps = {
  role: 'professional',
};

export default PrivateRoute;
